import { create } from "zustand";

import { User } from "@onair/repositories";
import { HostProfileStatus } from "@onair/types";

export enum LoginType {
	DEFAULT = "DEFAULT",
	SOCIAL = "SOCIAL",
}

export type AuthStore = User & {
	register: {
		step?: number
		email?: string,
		isNewUser?: boolean,
		loginType?: LoginType,
		hostStatus?: HostProfileStatus | null,
		isHostRegistrationActive?: boolean,
		shouldShowHostSignupDialog?: boolean,
		hasSubmittedHostRegistration?: boolean,
		isResubmittedHostRegistration?: boolean,
	} | undefined
};

export const INITIAL_STATE = {};

export const useAuthStore = create<AuthStore>(() => ({
	...(INITIAL_STATE as AuthStore),
}));
